import SelectableFieldsController from './selectable-fields-controller';

export default class extends SelectableFieldsController {
  static targets = ['select', 'fieldSet'];

  connect() {
    App.DynamicSelect.initEl(this.selectTarget);
    App.DynamicSelect.onChange(this.selectTarget, this.showSelectedFieldSet.bind(this));
    this.showSelectedFieldSet();
  }

  //
  // GETTERS AND SETTERS
  //

  get selectedValue() {
    return App.DynamicSelect.getValue(this.selectTarget);
  }
};



// WEBPACK FOOTER //
// ./app/components/forms/fields/assets/javascript/fields-select-controller.js